<template>
    <ul class="global-social-media container" aria-label="social media links" :class="styleClass">
        <li v-if="facebook">
            <a :href="facebook" target="_blank" aria-label="Go to Facebook page">
                <SvgsFacebook />
            </a>
        </li>
        <li v-if="instagram">
            <a :href="instagram" target="_blank" aria-label="Go to Instagram page">
                <SvgsInstagram />
            </a>
        </li>
        <li v-if="twitter">
            <a :href="twitter" target="_blank" aria-label="Go to Twitter page">
                <SvgsTwitter />
            </a>
        </li>
        <li v-if="website">
            <a :href="website" target="_blank" aria-label="Go to website">
                <SvgsWebLink />
            </a>
        </li>
        <li v-if="tiktok">
            <a :href="tiktok" target="_blank" aria-label="Go to TikTok page">
                <SvgsTiktok />
            </a>
        </li>
        <li v-if="linkedin">
            <a :href="linkedin" target="_blank" aria-label="Go to LinkedIn page">
                <SvgsLinkedin />
            </a>
        </li>
    </ul>
</template>

<script setup>
    const props = defineProps({
        facebook: {
            type: String,
            required: false,
        },
        website: {
            type: String,
            required: false,
        },
        instagram: {
            type: String,
            required: false,
        },
        twitter: {
            type: String,
            required: false,
        },
        linkedin: {
            type: String,
            required: false,
        },
        tiktok: {
            type: String,
            required: false,
        },

        styleClass: {
            type: String,
            required: false,
            default: 'space-between',
        },
    });
</script>

<style lang="scss" scoped>
    .global-social-media {
        display: flex;

        &.space-between {
            justify-content: space-between;
        }
        &:not(.space-between) {
            flex-wrap: wrap;
            li + li {
                margin-left: 20px;
            }
        }
    }
</style>
